export const trackRateType = type => {
    const values = [
        { name: 'free', value: 'Free' },
        { name: 'fixed', value: 'Fixed' },
        { name: 'open', value: 'Donation' }
    ];
    return values.find(it => it.name === type).value;
};
